import {usePage} from "@inertiajs/vue3";
import {computed} from "vue";
import {TeamRole} from "@/types";

const page = usePage()

const role = computed<TeamRole | null>(() => {
    return page.props.role as TeamRole | null
})

const isAdminOrOwner = computed(() => {
    return role.value === 'owner' || role.value === 'admin'
})

const isOwner = computed(() => {
    return role.value === 'owner'
})

export const useRole = () => {
    return {
        role,
        isAdminOrOwner,
        isOwner,
    }
}
